// extracted by mini-css-extract-plugin
export var copyableField = "_r8-4";
export var customerBadge = "_r8-0";
export var customerInfoTitle = "_r8-2";
export var details = "_r8-1";
export var dropdownContainer = "_r8-5";
export var dropdownImage = "_r8-6";
export var editAssigneeForm = "_r8-a";
export var editButton = "_r8-3";
export var email = "_r8-7";
export var hidden = "_r8-d";
export var input = "_r8-8";
export var saveButton = "_r8-b";
export var shopifyIcon = "_r8-c";
export var suggestionBadge = "_r8-e";
export var suggestionText = "_r8-f";
export var username = "_r8-9";